<template>
  <div class="app-header">
    <div :class="menuToggleClass" @click="toggleLeftMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div v-if="isTextVisible" class="video-on-off">
      <span>{{$t('on_off_video')}}</span>
    </div>
    <div :class="isExpandable" @click="toggleExpandBalance">
      <div class="icon">
        <image-svg :imageClass="imageClass" :imageName="'balance'" />
      </div>
      <div class="balance">
        <span>{{$t('balance')}}:</span>
        <span>{{formatCurrency(amount)}} {{currency}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import NumberFormat from '@/mixins/NumberFormat'
import VDogHelper from '@/mixins/VDogHelper'
import ImageSVG from '@/components/common/ImageSVG.vue'
import { store } from '@/store/store'
import vuexStore from '@/store/vuexStore'
import LanguageHelper from '@/mixins/LanguageHelper'

import generalMenuSound from '../../../src/assets/audio/general_menu.mp3'

export default {
  components: {
    'image-svg': ImageSVG
  },
  mixins: [NumberFormat, VDogHelper, LanguageHelper],
  props: {
    currency: {
      type: String,
      required: true
    },
    amount: {
      type: Number,
      required: true
    },
    isSoccer: {
      type: Boolean,
      required: false
    },
    imageName: String
  },
  data () {
    return {
      expandedBalance: false,
      hasAudioEnabled: vuexStore.state.hasAudioEnabled
    }
  },
  mounted: function () {
    this.$watch(
      () => vuexStore.state.hasAudioEnabled,
      () => {
        this.hasAudioEnabled = vuexStore.state.hasAudioEnabled
      }
    )
  },
  methods: {
    toggleLeftMenu () {
      if (this.hasAudioEnabled) {
        var audio = new Audio(generalMenuSound)
        audio.play()
      }
      this.$emit('onToggleLeftMenu')
    },
    formatCurrency: function (value) {
      return this.formatNumber(value, this.getLanguageCodeForNumbers())
    },
    toggleExpandBalance () {
      if (this.hasAudioEnabled) {
        var audio = new Audio(generalMenuSound)
        audio.play()
      }
      this.expandedBalance = !this.expandedBalance
    }
  },
  computed: {
    menuToggleClass: function () {
      return this.isSoccer ? 'a-vs-c--menu-toggle' : 'a-vg-c--menu-toggle'
    },
    logoUrl: function () {
      return store.getLogoUrl()
    },
    isTextVisible: function () {
      return store.isPauseAllowed() && store.isVideoAllowed()
    },
    logoClass: function () {
      return this.isSoccer ? 'a-vs-c-logo' : 'a-vg-c--logo'
    },
    balanseClass: function () {
      return this.isSoccer ? 'a-vs-c-logo' : 'a-vg-c--balance'
    },
    imageClass: function () {
      return this.isSoccer ? 'a-vs-icon' : 'a-vg-icon'
    },
    isExpandable: function () {
      return {
        'expanded-balance': this.expandedBalance,
        'a-vs-c--balance': this.isSoccer,
        'a-vg-c--balance': !this.isSoccer
      }
    }
  }
}
</script>
